import React from "react";
import { parseColourString } from "../../../../packages/ui/src/utils/uiHelpers";
import { Avatar } from "../atoms/atoms";
import "./quoteBox.scss";

interface Props {
  title: string;
  content: JSX.Element;
  avatarSource: string;
  cite: string;
  accentColor?: string;
}

export const QuoteBox: React.FC<Props> = ({ title, content, avatarSource, cite, accentColor }) => {
  const color = parseColourString(accentColor) || "var(--page-accent)";

  return (
    <blockquote className="quote-box">
      <div className="quote-box__text">
        <h3 className="quote-box__title">{title}</h3>
        <div className="quote-box__content">{content}</div>
      </div>
      <div className="quote-box__user" style={{
        color,
      }}>
        <Avatar className="quote-box__avatar" source={avatarSource} alt={cite} />
        <cite className="quote-box__cite">{cite}</cite>
      </div>
    </blockquote>
  );
};
